import { render, staticRenderFns } from "./NeumaticoVerticalTable.vue?vue&type=template&id=45ec1749&scoped=true"
import script from "./NeumaticoVerticalTable.vue?vue&type=script&lang=js"
export * from "./NeumaticoVerticalTable.vue?vue&type=script&lang=js"
import style0 from "./NeumaticoVerticalTable.vue?vue&type=style&index=0&id=45ec1749&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ec1749",
  null
  
)

export default component.exports